import Accettazione from "../";

const routes = [{ name: "Elenco Accettazioni", path: "/accettazione", component: Accettazione.AccettazioneList, meta: { title: "Elenco Accettazione" } }];

export default routes;
